import RecruitApiClient from '@/components/RecruitApiClient';

import type { JobsListingConfiguration, PublicClassification, PublicJob } from './types';

export interface ClassificationDetailsResponse {
  classificationId: number | null;
  classifications: PublicClassification[];
  expandedRootId: number | null;
  children: PublicClassification[];
  jobs: PublicJob[];
  currentPage: number;
  pageConfiguration?: JobsListingConfiguration | null;
  totalPages: number;
}

const ClassificationsApi = {
  getDetails: async (
    id?: number | null,
    q?: string,
    page?: number
  ): Promise<ClassificationDetailsResponse> =>
    RecruitApiClient.get<ClassificationDetailsResponse>('/classifications', {
      format: 'json',
      ...(id ? { id } : {}),
      ...(q ? { q } : {}),
      ...(page && page > 1 ? { page } : {})
    }).then(({ res }) => res)
};

export default ClassificationsApi;
